export default __webpack_public_path__ + "images/b5c5739c4ccab5c627d0d88b93a4a562.svg";